import DropdownMenu from '@/src/components/Commons/Controllers/DropdownMenu';
import { SwapOfferEntity } from '@/src/lib/MayzSmartDB';
import styles from './OfferPart.module.scss';

interface OfferPartProps {
    isBuy: boolean;
    swapOffer: SwapOfferEntity | undefined;
    swapOffers: SwapOfferEntity[];
    setSwapOffer: (current?: SwapOfferEntity | undefined) => void;
    show_SwapOffer: (swapOffer: SwapOfferEntity) => string;
    isLoadingSwapOffers: boolean;
}

export default function OfferPart(props: OfferPartProps) {
    //--------------------------------------
    const { isBuy, swapOffers, swapOffer, setSwapOffer, show_SwapOffer, isLoadingSwapOffers } = props;
    //--------------------------------------
    return (
        <section className={styles.offerSection}>
            <DropdownMenu
                name={'Offer'}
                namePlural={'Offers'}
                itemReact={(item) => {
                    if (item !== undefined) {
                        return show_SwapOffer(item);
                    } else {
                        null;
                    }
                }}
                items={swapOffers}
                selected={swapOffer}
                setSelected={setSwapOffer}
                styles={styles}
                className={'filterStyle'}
                swShowTitleInSelected={true}
                swCloseAutomatically={false}
                isLoadingItems={isLoadingSwapOffers}
            />
        </section>
    );
}
